import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import api from "../../api/axios";
import "../../assets/css/Expenses/ExpensesCreate.css";
import { MdClose } from "react-icons/md";
const EXPENSE_TYPES = [
  "Travel",
  "Demo",
  "Vendor",
  "Client Meeting",
  "Training",
  "Other",
];

export default function ExpensesCreate({
  onClose,
  refreshExpenses,
  leadId = null,
  organizationId = null,
  dealId = null,
}) {
  const [loading, setLoading] = useState(false);
//   const [context, setContext] = useState(null);

// const [loadingContext, setLoadingContext] = useState(true);
  const [form, setForm] = useState({
    expense_type: "",
    amount: "",
    expense_date: "",
    remarks: "",
  });

//   // =========================
//   // FETCH CONTEXT (IMPORTANT FIX)
//   // =========================
// useEffect(() => {
//   const fetchContext = async () => {
//     try {
//       setLoadingContext(true);

//       // If nothing passed, skip
//       if (!dealId && !leadId && !organizationId) return;

//       const res = await api.get("/expense/context", {
//         params: {
//           deal_id: dealId,
//           lead_id: leadId,
//           organization_id: organizationId,
//         },
//       });

//       setContext(res.data);
//     } catch (err) {
//       console.error("Context fetch failed:", err);
//       setContext(null);
//     } finally {
//       setLoadingContext(false);
//     }
//   };

//   fetchContext();
// }, [dealId, leadId, organizationId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "amount") {
      const rawValue = value.replace(/,/g, "").replace(/\D/g, "");

      setForm((prev) => ({
        ...prev,
        [name]: rawValue,
      }));

      return;
    }
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));    



  };

  const submit = async (e) => {
    e.preventDefault();

    if (!form.expense_type || !form.amount || !form.expense_date) {
      return Swal.fire({
        icon: "warning",
        title: "Please fill required fields",
      });
    }

    try {
      setLoading(true);

      const payload = {
    expense_type: form.expense_type,
    amount: Number(form.amount),
    expense_date: form.expense_date,
    remarks: form.remarks || "",

    related_to: "Lead",

    lead_id: leadId ? Number(leadId) : null,
    organization_id: organizationId ? Number(organizationId) : null,
    deal_id: dealId ? Number(dealId) : null,
};

      await api.post("/expense", payload);

      await Swal.fire({
        icon: "success",
        title: "Expense Created",
        timer: 1200,
        showConfirmButton: false,
      });

      refreshExpenses?.();
      onClose?.();
    }catch (err) {

    let message = "Failed to create expense";

    const detail = err.response?.data?.detail;

    if (typeof detail === "string") {
        message = detail;
    }
    else if (Array.isArray(detail)) {
        message = detail
            .map(item => item.msg)
            .join("\n");
    }


    Swal.fire({
        icon:"error",
        title:"Error",
        text:message
    });

}
  };

  return (
  <div className="expense-overlay" onClick={onClose}>
    <div
      className="expense-card-a"
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div className="expense-header">
        <h2 className="expense-title">Create Expense</h2>

        <button
          className="expense-close"
          onClick={onClose}
        >
          <MdClose />
        </button>
      </div>

      {/* BODY */}
      <form className="expense-body" onSubmit={submit}>

      

        {/* EXPENSE TYPE */}
        <div className="expense-group">
          <label>Expense Type</label>
          <select
            name="expense_type"
            value={form.expense_type}
            onChange={handleChange}
          >
            <option value="">Select Type</option>
            {EXPENSE_TYPES.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>

        {/* AMOUNT */}
        <div className="expense-group">
          <label>Amount</label>
          

           <input
                type="text"
                name="amount"
                value={
                  form.amount
                    ? Number(form.amount).toLocaleString("en-IN")
                    : ""
                }
                onChange={handleChange}
                placeholder="1,25,000"
                required
              />
        </div>

        {/* DATE */}
        <div className="expense-group">
          <label>Date</label>
          <input
            type="date"
            name="expense_date"
            value={form.expense_date}
            onChange={handleChange}
          />
        </div>

        {/* EMPTY GRID SLOT (keeps alignment clean) */}
        <div></div>

        {/* REMARKS (FULL WIDTH) */}
        <div className="expense-group expense-full">
          <label>Remarks</label>
          <textarea
            name="remarks"
            value={form.remarks}
            onChange={handleChange}
            rows="5"
            placeholder="Enter remarks..."
          />
        </div>
      </form>

      {/* FOOTER (OUTSIDE GRID - IMPORTANT FIX) */}
      <div className="expense-footer">
        <button
          type="button"
          className="expense-btn expense-btn--secondary"
          onClick={onClose}
        >
          Cancel
        </button>

        <button
          type="button"
          className="expense-btn expense-btn--primary"
          onClick={submit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Expense"}
        </button>
      </div>
    </div>
  </div>
);
}